module.exports = __webpack_public_path__ + "media/images/cancellation-selection-ea05f07ef94e9dd641a1429ab4025500.svg";